import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiBook, FiHelpCircle, FiDollarSign, FiInfo } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

/**
 * PublicPageHeader component for footer/public pages
 * Handles auth state to show appropriate buttons (Sign In vs Dashboard)
 */
const PublicPageHeader = ({ showBackLink = true, backTo = '/' }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  const navLinks = [
    { to: '/docs', label: 'Docs', icon: FiBook },
    { to: '/pricing', label: 'Pricing', icon: FiDollarSign },
    { to: '/help', label: 'Help', icon: FiHelpCircle },
    { to: '/about', label: 'About', icon: FiInfo },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-3">
              <img src="/icon.png" alt="Tasklina" className="w-9 h-9" />
              <span className="text-xl font-semibold text-gray-900 dark:text-white">Tasklina</span>
            </Link>
            
            {/* Navigation Links */}
            <nav className="hidden md:flex items-center space-x-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                    isActive(link.to)
                      ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30'
                      : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
          
          <div className="flex items-center space-x-4">
            {showBackLink && !navLinks.some(l => isActive(l.to)) && (
              <Link 
                to={backTo}
                className="hidden sm:flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
              >
                <FiArrowLeft className="w-4 h-4" />
                <span className="text-sm font-medium">Back to Home</span>
              </Link>
            )}
            {!loading && (
              currentUser ? (
                <Link 
                  to="/dashboard" 
                  className="px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors shadow-sm"
                >
                  Dashboard
                </Link>
              ) : (
                <Link 
                  to="/auth/login" 
                  className="px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors shadow-sm"
                >
                  Sign In
                </Link>
              )
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicPageHeader;
